import { parseISO, format } from 'date-fns';

const formatTimestampDate = (timestamp) => {
  if (timestamp) {
    let date;
    if (typeof timestamp === 'string') {
      date = parseISO(timestamp);
    } else if (timestamp.seconds) {
      date = new Date(timestamp.seconds * 1000);
    } else {
      date = new Date(timestamp);
    }

    if (isNaN(date.getTime())) {
      return 'Invalid Timestamp';
    }

    return format(date, 'd MMMM, yyyy');
  }
  return '--';
};

const FormatTimestamp = ({ timestamp }) => {
  return <span>{formatTimestampDate(timestamp)}</span>;
};

export default FormatTimestamp;